module.exports = __webpack_public_path__ + "img/_Middle-Horizontal-Rectangular-Attachment.c58bf045.jpg";